<div class="flex">
  <app-graphic-side-panel
    class="hidden h-screen w-[50vw] md:flex"
    [subtext]="'Login successful'"
  ></app-graphic-side-panel>
  <div
    class="flex h-screen w-screen flex-col items-center justify-center md:w-[50vw]"
  >
    <div class="flex w-full justify-end">
      <app-theme-toggle
        class="tooltip tooltip-left mr-4 mt-4"
        data-tip="Light/Dark mode toggle"
      ></app-theme-toggle>
    </div>
    <div class="mx-6 my-auto w-full max-w-lg text-center">
      <img
        class="mx-auto my-4 w-36 md:hidden"
        src="../../../assets/accuzip-logo-white.png"
        alt="AccuZIP Logo"
      />
      <div class="mb-6 flex justify-center text-success">
        <app-check-circle-icon class="h-16 w-16"></app-check-circle-icon>
      </div>
      <h1
        class="z-10 m-auto max-w-lg text-3xl font-semibold leading-normal md:text-5xl"
      >
        Login Successful
      </h1>
      <p class="mt-6 text-base-content/80">
        You may now close this window and return to the desktop application.
      </p>
    </div>
    <div class="text-center text-base-content/70">
      <p class="pb-6 text-sm">
        <span class="select-none">© 2026 AccuZIP, Inc.</span>
      </p>
    </div>
  </div>
</div>
